/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabQueryResponse,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabPathParams,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab400,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab401,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab500,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab } from "../../clients/courseRegistrationEnrollmentController/getApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab.ts";

export const getApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabQueryKey =
  (
    courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabPathParams["courseRegistrationId"],
  ) =>
    [
      {
        url: "/api/v1/courseregistration/enrollment/:courseRegistrationId/selective-process-tab",
        params: { courseRegistrationId: courseRegistrationId },
      },
    ] as const;

export type GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabQueryKey =
  ReturnType<
    typeof getApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabQueryKey
  >;

export function getApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabQueryOptions(
  courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabPathParams["courseRegistrationId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabQueryKey(
      courseRegistrationId,
    );
  return queryOptions<
    GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabQueryResponse,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab400
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab401
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab500
    >,
    GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabQueryResponse,
    typeof queryKey
  >({
    enabled: !!courseRegistrationId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab(
        courseRegistrationId,
        { ...config, signal: config.signal ?? signal },
      );
    },
  });
}

/**
 * @description Retorna informações do processo seletivo vinculado à matrícula, incluindo status, tipo de admissão, datas de vestibular e entrevista, flags de presença e aprovação de documentação, motivo de rejeição e notas (vestibular e redação). As notas são retornadas na escala 0–10. Requer permissão de empresa sobre a matrícula. **(Requer Authorization para autenticação)**
 * @summary Retorna dados do processo seletivo de uma matrícula (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/enrollment/:courseRegistrationId/selective-process-tab}
 */
export function useGetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab<
  TData =
    GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabQueryResponse,
  TQueryData =
    GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabQueryKey,
>(
  courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabPathParams["courseRegistrationId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabQueryResponse,
        ResponseErrorConfig<
          | GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab400
          | GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab401
          | GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabQueryKey(
      courseRegistrationId,
    );

  const query = useQuery(
    {
      ...getApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabQueryOptions(
        courseRegistrationId,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab400
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab401
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
